import { Grid2Props as GridProps } from "@mui/material";
import { PropsWithChildren } from "react";
import { NestedGrid } from "src/components/layout/page-grid/deprecated/NestedGrid";

/**
 * NestedGrid used to structure content inside a page section in the FPP.
 */
export const FPPNestedGrid = (props: PropsWithChildren<GridProps>) => {
    return <NestedGrid columnSpacing={{ xs: 2, sm: 4 }} rowSpacing={{ xs: 2, sm: 4 }} {...props} />;
};
